import mobileFooterStore from './store/footerStore';
import store from '@/core/store';

export const connect = (opts = {}) => {
  store.registerModule('mobileFooterStore$mobileFooterStore', mobileFooterStore);
};
